import { init } from 'mixpanel'

export default {
  install (Vue, options) {
    if (!options.token) {
      return false
    }

    let token = options.token
    Vue.mixpanel = init(token, options)
    Vue.mixpanel.responseBodyToMixpanelValue = responseBodyToMixpanelValue

    Vue.mixin({
      mounted () {
        this.$mixpanel = Vue.mixpanel
      }
    })
  }
}

/**
 * Mixpanel property value is <= 256 so we need to ensure body length doesn't exceed that
 * Additionally, if the body is an error message, start the value at that point so we may capture a more descriptive value
 * @param {*} body
 * @param {*} length
 */
export function responseBodyToMixpanelValue (body, length = 255) {
  let errMsgFlag = '<div id="summary">'
  if (body && typeof body === 'object') {
    return JSON.stringify(body).substr(0, length)
  }
  let bodyString = String(body)
  let bodyErrorParsed = body.match(errMsgFlag)
  // Is the body an error message from Django? If so, start body at that point
  if (bodyErrorParsed) {
    let substrStartAt = bodyErrorParsed.index + errMsgFlag.length
    bodyString = bodyString.substr(substrStartAt)
  }
  return bodyString.substr(0, length)
}



// WEBPACK FOOTER //
// ./src/plugins/mixpanel/index.js